import { createFileRoute } from '@tanstack/react-router'

import PagePlayground from '../pages/PagePlayground'

export const Route = createFileRoute('/playground/')({
  component: PagePlayground
})
